var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.36,247.16c-95.82-55.32-250.65-55.32-345.85,0s-94.69,145,1.12,200.33,250.66,55.32,345.86,0S518.18,302.48,422.36,247.16Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.22,383.76c-6.73-3.88-17.6-3.88-24.28,0s-6.64,10.18.08,14.06,17.59,3.89,24.28,0S63.94,387.65,57.22,383.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1,342.59l3.4,2a4.9,4.9,0,0,0,4.86,0l204.38-118a1.94,1.94,0,0,0,0-3.36l-3.47-2a4.85,4.85,0,0,0-4.87,0L47.1,339.23A1.94,1.94,0,0,0,47.1,342.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.19,364.54l1.17.68a1.7,1.7,0,0,0,1.69,0L143,324.28a.68.68,0,0,0,0-1.17l-1.2-.7a1.72,1.72,0,0,0-1.7,0l-70.88,41A.68.68,0,0,0,69.19,364.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,359.9l-55-31.85a9.92,9.92,0,0,0-9.94,0L314.91,357l-51.49-29.62a6.61,6.61,0,0,0-6.61,0l-89.68,51.79a1.11,1.11,0,0,0,0,1.91L318,468a6.61,6.61,0,0,0,6.61,0l89.68-51.8a1.1,1.1,0,0,0,0-1.91l-36-20.72L430,363.72A2.21,2.21,0,0,0,430,359.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,386.86c-7.08-4.09-18.54-4.09-25.58,0s-7,10.73.08,14.82,18.55,4.09,25.59,0S474.08,391,467,386.86Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4,361.42l-16.28.48-16.28-.48c-.7,11,1.44,22.2,4.4,27.68h0a7.4,7.4,0,0,0,3.22,3.28c4.8,2.77,12.57,2.77,17.34,0A7.29,7.29,0,0,0,57,389C60,383.51,62.1,372.36,61.4,361.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.59,354.76c6.38,3.68,6.42,9.65.08,13.33s-16.65,3.69-23,0-6.41-9.65-.07-13.33S50.22,351.07,56.59,354.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.07,356.22c5,2.87,5,7.53.06,10.41s-13,2.87-18,0-5-7.54-.06-10.41S49.1,353.35,54.07,356.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.07,356.22c5,2.87,5,7.53.06,10.41s-13,2.87-18,0-5-7.54-.06-10.41S49.1,353.35,54.07,356.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.82,328.11c-2.65-3.3-5.73-6.25-8.16-9.7-1.65-2.36-3-5.25-2.34-8.05a7.2,7.2,0,0,1,5.7-5,10.9,10.9,0,0,1,7.65,1.7,23.64,23.64,0,0,1,5.78,5.51,57.45,57.45,0,0,1,12.1,41A8.51,8.51,0,0,1,56,358.3a4.71,4.71,0,0,1-4.86,1.49c-4.44-1.32-3.85-7.31-4.58-10.84a49.48,49.48,0,0,0-5.09-13.83A48.67,48.67,0,0,0,36.82,328.11Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.82,328.11c-2.65-3.3-5.73-6.25-8.16-9.7-1.65-2.36-3-5.25-2.34-8.05a7.2,7.2,0,0,1,5.7-5,10.9,10.9,0,0,1,7.65,1.7,23.64,23.64,0,0,1,5.78,5.51,57.45,57.45,0,0,1,12.1,41A8.51,8.51,0,0,1,56,358.3a4.71,4.71,0,0,1-4.86,1.49c-4.44-1.32-3.85-7.31-4.58-10.84a49.48,49.48,0,0,0-5.09-13.83A48.67,48.67,0,0,0,36.82,328.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.45,355.32a.38.38,0,0,1-.31-.36c-.31-7.12-2.63-31.42-19.37-45.21a.39.39,0,1,1,.49-.6c17,14,19.34,38.57,19.65,45.77a.38.38,0,0,1-.37.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,356.09a11.87,11.87,0,0,1-5.44,7.54A15.28,15.28,0,0,1,40.23,365a35.5,35.5,0,0,1-8.35-2c-1.35-.45-2.84-1.06-3-2.73a3,3,0,0,1,1-2.34,7.88,7.88,0,0,1,.87-.74.87.87,0,0,0-.46-1.55,18.86,18.86,0,0,1-2.38-.29,10.53,10.53,0,0,1-5-2.26,8.25,8.25,0,0,1-2.31-3.42c-.4-1.12-.52-2.52.33-3.36a3.6,3.6,0,0,1,1.85-.8c.6-.13,1.19-.24,1.79-.33a.8.8,0,0,0,.19-1.52l-2.53-1.05a4.94,4.94,0,0,1-1.92-1.19A4.2,4.2,0,0,1,19.8,338c.31-1.58.85-3.11,1.22-4.68a9.93,9.93,0,0,0,.17-4.78,40.1,40.1,0,0,1,14.15.95,9.93,9.93,0,0,1,3.86,1.69c1.58,1.26,2,3.15,1.82,5.2a.37.37,0,0,0,.69.19l1.61-3a1.93,1.93,0,0,1,2.51-.8,11.69,11.69,0,0,1,3.69,2.9,6.41,6.41,0,0,1,1.58,4.73,40.64,40.64,0,0,1-1.18,6.93.65.65,0,0,0,1,.68L51,348a2.21,2.21,0,0,1,1.52-.45c1.42.18,1.79,1.63,1.88,2.86A24,24,0,0,1,53.9,356.09Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,356.09a11.87,11.87,0,0,1-5.44,7.54A15.28,15.28,0,0,1,40.23,365a35.5,35.5,0,0,1-8.35-2c-1.35-.45-2.84-1.06-3-2.73a3,3,0,0,1,1-2.34,7.88,7.88,0,0,1,.87-.74.87.87,0,0,0-.46-1.55,18.86,18.86,0,0,1-2.38-.29,10.53,10.53,0,0,1-5-2.26,8.25,8.25,0,0,1-2.31-3.42c-.4-1.12-.52-2.52.33-3.36a3.6,3.6,0,0,1,1.85-.8c.6-.13,1.19-.24,1.79-.33a.8.8,0,0,0,.19-1.52l-2.53-1.05a4.94,4.94,0,0,1-1.92-1.19A4.2,4.2,0,0,1,19.8,338c.31-1.58.85-3.11,1.22-4.68a9.93,9.93,0,0,0,.17-4.78,40.1,40.1,0,0,1,14.15.95,9.93,9.93,0,0,1,3.86,1.69c1.58,1.26,2,3.15,1.82,5.2a.37.37,0,0,0,.69.19l1.61-3a1.93,1.93,0,0,1,2.51-.8,11.69,11.69,0,0,1,3.69,2.9,6.41,6.41,0,0,1,1.58,4.73,40.64,40.64,0,0,1-1.18,6.93.65.65,0,0,0,1,.68L51,348a2.21,2.21,0,0,1,1.52-.45c1.42.18,1.79,1.63,1.88,2.86A24,24,0,0,1,53.9,356.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,356.09a11.87,11.87,0,0,1-5.44,7.54A15.28,15.28,0,0,1,40.23,365a35.5,35.5,0,0,1-8.35-2c-1.35-.45-2.84-1.06-3-2.73a3,3,0,0,1,1-2.34,7.88,7.88,0,0,1,.87-.74.87.87,0,0,0-.46-1.55,18.86,18.86,0,0,1-2.38-.29,10.53,10.53,0,0,1-5-2.26,8.25,8.25,0,0,1-2.31-3.42c-.4-1.12-.52-2.52.33-3.36a3.6,3.6,0,0,1,1.85-.8c.6-.13,1.19-.24,1.79-.33a.8.8,0,0,0,.19-1.52l-2.53-1.05a4.94,4.94,0,0,1-1.92-1.19A4.2,4.2,0,0,1,19.8,338c.31-1.58.85-3.11,1.22-4.68a9.93,9.93,0,0,0,.17-4.78,40.1,40.1,0,0,1,14.15.95,9.93,9.93,0,0,1,3.86,1.69c1.58,1.26,2,3.15,1.82,5.2a.37.37,0,0,0,.69.19l1.61-3a1.93,1.93,0,0,1,2.51-.8,11.69,11.69,0,0,1,3.69,2.9,6.41,6.41,0,0,1,1.58,4.73,40.64,40.64,0,0,1-1.18,6.93.65.65,0,0,0,1,.68L51,348a2.21,2.21,0,0,1,1.52-.45c1.42.18,1.79,1.63,1.88,2.86A24,24,0,0,1,53.9,356.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,363.25a57.3,57.3,0,0,0-3.81-11,.39.39,0,0,0-.13-.29l-.27-.58A35.7,35.7,0,0,1,46,338.72a.39.39,0,1,0-.67-.38,36.1,36.1,0,0,0-3.72,11.73c-3.22-6.46-8.36-14-16.29-19.53a.39.39,0,0,0-.54.09.41.41,0,0,0,.09.55c8.19,5.69,13.35,13.58,16.49,20.13a23.74,23.74,0,0,0-13.49-1.82.39.39,0,0,0-.31.45.4.4,0,0,0,.31.31H28c.07,0,7.48-1.36,13.88,2.22a57.08,57.08,0,0,1,3.77,10.92.41.41,0,0,0,.31.31h.15A.39.39,0,0,0,46.4,363.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.4,363.31l-17.16.5-17.15-.5c-.74,11.59,1.52,23.4,4.64,29.17h0a7.82,7.82,0,0,0,3.4,3.45c5.06,2.93,13.24,2.93,18.27,0a7.57,7.57,0,0,0,3.4-3.54C469.9,386.59,472.14,374.84,471.4,363.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.34,356.29c6.72,3.88,6.76,10.17.08,14s-17.55,3.88-24.27,0-6.76-10.17-.08-14S459.61,352.4,466.34,356.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.68,357.83c5.24,3,5.27,7.94.06,11s-13.69,3-18.93,0-5.27-7.94-.06-11S458.43,354.8,463.68,357.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M463.68,357.83c5.24,3,5.27,7.94.06,11s-13.69,3-18.93,0-5.27-7.94-.06-11S458.43,354.8,463.68,357.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M482.46,290.09c-38.67,12.66-39,38.53-30.31,57,2.2,3.72,8.86,5.73,14.65-17.18l-10.16,1.3,11.84-6,3.07-9.19-9.87.73,12.53-5.27A183.64,183.64,0,0,1,482.46,290.09Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.46,290.09c-38.67,12.66-39,38.53-30.31,57,2.2,3.72,8.86,5.73,14.65-17.18l-10.16,1.3,11.84-6,3.07-9.19-9.87.73,12.53-5.27A183.64,183.64,0,0,1,482.46,290.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.46,290.09c-38.67,12.66-39,38.53-30.31,57,2.2,3.72,8.86,5.73,14.65-17.18l-10.16,1.3,11.84-6,3.07-9.19-9.87.73,12.53-5.27A183.64,183.64,0,0,1,482.46,290.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.52,296.56c-20.39,15.48-22.23,33.22-16.47,51.75C453,332,450.81,315.5,471.52,296.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,316.37c38.12,5.37,42.74,29.4,37.68,48-1.42,3.84-7.29,6.81-16.49-13.57l9.68-.47-12-3.62-4.39-8.05,9.31-1-12.54-2.83A175.77,175.77,0,0,0,417,316.37Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,316.37c38.12,5.37,42.74,29.4,37.68,48-1.42,3.84-7.29,6.81-16.49-13.57l9.68-.47-12-3.62-4.39-8.05,9.31-1-12.54-2.83A175.77,175.77,0,0,0,417,316.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,316.37c38.12,5.37,42.74,29.4,37.68,48-1.42,3.84-7.29,6.81-16.49-13.57l9.68-.47-12-3.62-4.39-8.05,9.31-1-12.54-2.83A175.77,175.77,0,0,0,417,316.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.22,320.58c21.56,11,26.23,27.24,23.94,45.45C451.35,350.5,450.66,334.78,428.22,320.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.61,325.38c-34.95.57-41.81,21.71-39.33,39.05.85,3.62,5.81,6.95,16.38-10.38L462,352.54l11.24-1.92,4.86-6.76L469.8,342l11.62-1.14A158.1,158.1,0,0,1,493.61,325.38Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,327.91c-20.67,7.52-26.68,21.62-26.66,38.29C458.8,352.29,461.18,338.2,483,327.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.61,325.38c-34.95.57-41.81,21.71-39.33,39.05.85,3.62,5.81,6.95,16.38-10.38L462,352.54l11.24-1.92,4.86-6.76L469.8,342l11.62-1.14A158.1,158.1,0,0,1,493.61,325.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3,306.46,51,149.68a15.43,15.43,0,0,1,7-12.12L252.83,25.33c1.92-1.11,3.67-1.22,4.94-.51l-7.33-4.25h0c-1.29-.82-3.1-.75-5.1.41L50.46,133.22a15.42,15.42,0,0,0-7,12.11l.35,156.78c0,2.1.72,3.6,1.87,4.38h0a2.5,2.5,0,0,0,.39.23l7.24,4.21C52.08,310.19,51.31,308.65,51.3,306.46Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44,20.57h0c-1.29-.82-3.1-.75-5.1.41L50.46,133.22a14.6,14.6,0,0,0-5.36,6l7.49,4.33a14.78,14.78,0,0,1,5.36-6L252.83,25.33c1.92-1.11,3.67-1.22,4.94-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,145.33l.35,156.78c0,2.1.72,3.6,1.87,4.38h0a2.5,2.5,0,0,0,.39.23l7.24,4.21c-1.24-.74-2-2.28-2-4.47L51,149.68a14,14,0,0,1,1.64-6.16l-7.49-4.33A13.77,13.77,0,0,0,43.46,145.33Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,158.77l.33,147.69c0,2.19.78,3.73,2,4.47a.41.41,0,0,0,.11.07l0,0c1.26.67,3,.54,4.87-.55L253.23,198.24a15.39,15.39,0,0,0,7-12.11l-.33-147.94Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,158.77l.33,147.69c0,2.19.78,3.73,2,4.47a.41.41,0,0,0,.11.07l0,0c1.26.67,3,.54,4.87-.55L253.23,198.24a15.39,15.39,0,0,0,7-12.11l-.33-147.94Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.87,29.35c0-2.19-.78-3.74-2-4.48a.05.05,0,0,1,0,0l-.05,0c-1.27-.71-3-.6-4.94.51L58,137.56a15.43,15.43,0,0,0-7,12.12l0,9.09L259.89,38.19Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.23,143.92c1.06-.61,1.92-.12,1.92,1.09a4.21,4.21,0,0,1-1.91,3.3c-1.05.61-1.91.12-1.92-1.09A4.21,4.21,0,0,1,60.23,143.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.46,140.9c1.06-.61,1.91-.12,1.92,1.09a4.21,4.21,0,0,1-1.91,3.31c-1.06.61-1.92.12-1.92-1.1A4.21,4.21,0,0,1,65.46,140.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,137.88c1.06-.61,1.92-.12,1.92,1.09a4.2,4.2,0,0,1-1.9,3.31c-1.06.61-1.92.12-1.92-1.1A4.2,4.2,0,0,1,70.68,137.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.23,143.92c1.06-.61,1.92-.12,1.92,1.09a4.21,4.21,0,0,1-1.91,3.3c-1.05.61-1.91.12-1.92-1.09A4.21,4.21,0,0,1,60.23,143.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.46,140.9c1.06-.61,1.91-.12,1.92,1.09a4.21,4.21,0,0,1-1.91,3.31c-1.06.61-1.92.12-1.92-1.1A4.21,4.21,0,0,1,65.46,140.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,137.88c1.06-.61,1.92-.12,1.92,1.09a4.2,4.2,0,0,1-1.9,3.31c-1.06.61-1.92.12-1.92-1.1A4.2,4.2,0,0,1,70.68,137.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "199.38 172.5 226.79 156.68 226.78 153.21 199.37 169.03 199.38 172.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.37 146.51 230.62 150.99 230.63 154.46 238.38 149.98 238.37 146.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.98 188.26 250.46 151.61 250.45 148.14 186.97 184.79 186.98 188.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.13 191.64 181.12 188.17 173.36 192.65 173.37 196.11 181.13 191.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.32 171.37 157.93 192.96 157.94 196.43 195.34 174.84 195.32 171.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.76 173.55 154.01 178.03 154.02 181.5 161.77 177.02 161.76 173.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.65 199.48 152.64 196.01 128.16 210.15 128.17 213.62 152.65 199.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.83 233.88 116.84 237.35 140.46 223.71 140.45 220.25 116.83 233.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.55 199.48 167.54 196.01 128.18 218.73 128.19 222.2 167.55 199.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.1 158.87 215.86 154.39 215.85 150.92 208.09 155.4 208.1 158.87",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.59 171.86 179.6 175.33 202.09 162.34 202.08 158.87 179.59 171.86",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.67 194.34 172.24 179.57 172.23 176.11 146.66 190.87 146.67 194.34",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.26 198.62 139.25 195.15 116.76 208.13 116.77 211.6 139.26 198.62",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.05 208.62 148.37 184.76 148.36 181.29 107.04 205.15 107.05 208.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.14 145.24 172.13 141.77 106.17 179.85 106.18 183.32 172.14 145.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.55 161.24 129.54 157.76 106.15 171.27 106.16 174.74 129.55 161.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.29 145.27 106.12 162.68 106.13 166.16 136.3 148.75 136.29 145.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.56 156.61 201.05 119.96 201.04 116.48 137.55 153.14 137.56 156.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.15 131.49 143.54 141.08 143.56 144.55 160.16 134.97 160.15 131.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.73 127.88 82.39 150.6 82.39 154.07 121.74 131.35 121.73 127.88",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.3 145.39 82.41 159.18 82.42 162.65 106.31 148.86 106.3 145.39",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.7 142.86 190.99 99.97 190.98 96.5 116.69 139.39 116.7 142.86",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.86 82.14 221.85 78.67 198.31 92.27 198.32 95.73 221.86 82.14",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.85 71.18 240.85 67.71 229.07 74.5 229.08 77.97 240.85 71.18",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.82 147.33 94.38 160.87 94.39 164.34 117.83 150.8 117.82 147.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.56 106.94 207.11 112.97 207.12 116.45 217.57 110.42 217.56 106.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.29 91.53 250.28 88.05 222.87 103.87 222.88 107.35 250.29 91.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.51 150.68 192.5 147.2 128.59 184.1 128.6 187.57 192.51 150.68",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.3 188.31 94.5 203.78 94.51 207.26 121.31 191.78 121.3 188.31",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.85 187.48 94.47 195.2 94.48 198.68 107.86 190.96 107.85 187.48",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.27 202.92 214.03 198.44 214.02 194.96 206.26 199.44 206.27 202.92",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.06 205.93 201.05 202.45 176.19 216.81 176.2 220.28 201.06 205.93",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.55 182.47 141.48 245.44 141.49 248.91 250.56 185.95 250.55 182.47",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171 219.8 141.46 236.86 141.47 240.33 171.01 223.28 171 219.8",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.9 259.63 116.91 263.11 135.97 252.1 135.96 248.63 116.9 259.63",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.93 240.04 106.39 257.1 106.4 260.58 135.94 243.52 135.93 240.04",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.88 239.56 106.37 248.52 106.38 252 121.89 243.04 121.88 239.56",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "208.1 158.87 215.86 154.39 215.85 150.92 208.09 155.4 208.1 158.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.59 171.86 179.6 175.33 202.09 162.34 202.08 158.87 179.59 171.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.67 194.34 172.24 179.57 172.23 176.11 146.66 190.87 146.67 194.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.26 198.62 139.25 195.15 116.76 208.13 116.77 211.6 139.26 198.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "121.73 127.88 82.39 150.6 82.39 154.07 121.74 131.35 121.73 127.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.3 145.39 82.41 159.18 82.42 162.65 106.31 148.86 106.3 145.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.7 142.86 190.99 99.97 190.98 96.5 116.69 139.39 116.7 142.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.86 82.14 221.85 78.67 198.31 92.27 198.32 95.73 221.86 82.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.85 71.18 240.85 67.71 229.07 74.5 229.08 77.97 240.85 71.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "192.51 150.68 192.5 147.2 128.59 184.1 128.6 187.57 192.51 150.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.3 188.31 94.5 203.78 94.51 207.26 121.31 191.78 121.3 188.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.85 187.48 94.47 195.2 94.48 198.68 107.86 190.96 107.85 187.48",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "206.27 202.92 214.03 198.44 214.02 194.96 206.26 199.44 206.27 202.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.06 205.93 201.05 202.45 176.19 216.81 176.2 220.28 201.06 205.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.55 182.47 141.48 245.44 141.49 248.91 250.56 185.95 250.55 182.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171 219.8 141.46 236.86 141.47 240.33 171.01 223.28 171 219.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.9 259.63 116.91 263.11 135.97 252.1 135.96 248.63 116.9 259.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.93 240.04 106.39 257.1 106.4 260.58 135.94 243.52 135.93 240.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.88 239.56 106.37 248.52 106.38 252 121.89 243.04 121.88 239.56",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "64.94 191.8 64.97 200.4 64.94 191.8 64.94 191.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.97 203.7 72.45 199.38 72.45 199.38 64.97 203.7 65 212.29 65 212.29 64.97 203.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.43,
    y: 213.43,
    width: 8.64,
    transform: "translate(-97.51 62.97) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.55,
    y: 256.69,
    width: 8.64,
    transform: "translate(-119.12 68.82) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.38 172.29 64.9 176.61 72.38 172.29 72.38 172.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.22 177.41 64.91 179.9 64.93 188.5 64.91 179.9 69.22 177.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.41 184.18 64.93 188.5 72.41 184.18 72.41 184.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.44 196.08 64.97 200.4 72.44 196.08 72.44 196.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.48 268.25 65.16 270.75 65.19 279.34 65.19 279.34 65.16 270.75 69.48 268.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.48,
    y: 232.9,
    width: 8.64,
    transform: "translate(-107.23 65.6) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.52,
    y: 244.8,
    width: 8.64,
    transform: "translate(-113.17 67.21) rotate(-30)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.42 187.48 64.94 191.8 64.97 200.4 72.44 196.08 72.42 187.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65 212.29 72.48 207.97 72.45 199.38 64.97 203.7 65 212.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.58 242.64 65.1 246.96 65.12 255.55 72.6 251.23 72.58 242.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.16 267.44 72.63 263.13 72.61 254.53 65.13 258.85 65.16 267.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.54 230.74 65.06 235.06 65.09 243.66 72.57 239.34 72.54 230.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.94,226.58l-12.3,7.11.18,61.71,12.3-7.1Zm-2.33,27.95,0,8.6-7.48,4.31,0-8.59h0l7.48-4.32Zm-7.55-19.47h0l7.48-4.32h0l0,8.6-7.48,4.31Zm0,11.9h0l7.48-4.32h0l0,8.59-7.48,4.32Zm.09,32.38,0-8.59,4.32-2.5,3.16-1.82,0,8.59-7.48,4.32Zm0,11.89,0-8.59,7.48-4.32,0,8.59Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.75,159.53l-12.3,7.1.18,61.72,12.3-7.1ZM64.87,168l7.48-4.32,0,8.6h0l-7.48,4.32Zm0,11.89,4.31-2.49,3.17-1.82,0,8.59h0l-7.48,4.32Zm0,11.9h0l7.48-4.32,0,8.6h0L65,200.4Zm0,11.9,7.48-4.32h0l0,8.6L65,212.29h0Zm0,11.89h0l7.48-4.32h0l0,8.6L65,224.18Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.94,226.58l-12.3,7.11.18,61.71,12.3-7.1Zm-2.33,27.95,0,8.6-7.48,4.31,0-8.59h0l7.48-4.32Zm-7.55-19.47h0l7.48-4.32h0l0,8.6-7.48,4.31Zm0,11.9h0l7.48-4.32h0l0,8.59-7.48,4.32Zm.09,32.38,0-8.59,4.32-2.5,3.16-1.82,0,8.59-7.48,4.32Zm0,11.89,0-8.59,7.48-4.32,0,8.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.75,159.53l-12.3,7.1.18,61.72,12.3-7.1ZM64.87,168l7.48-4.32,0,8.6h0l-7.48,4.32Zm0,11.89,4.31-2.49,3.17-1.82,0,8.59h0l-7.48,4.32Zm0,11.9h0l7.48-4.32,0,8.6h0L65,200.4Zm0,11.9,7.48-4.32h0l0,8.6L65,212.29h0Zm0,11.89h0l7.48-4.32h0l0,8.6L65,224.18Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.41 184.18 72.39 175.59 69.22 177.41 64.91 179.9 64.93 188.5 72.41 184.18 72.41 184.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.75 159.53 74.74 154.74 62.44 161.84 62.45 166.63 74.75 159.53 74.75 159.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.38 172.29 72.35 163.69 64.87 168.01 64.9 176.61 72.38 172.29 72.38 172.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.49 211.27 72.49 211.27 65.01 215.59 65.01 215.59 65.03 224.19 72.51 219.87 72.49 211.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.67 275.02 72.64 266.43 69.48 268.25 65.16 270.75 65.19 279.34 65.19 279.34 72.67 275.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.2 282.64 65.22 291.23 72.7 286.92 72.68 278.32 65.2 282.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,104.08v-3.32a4.57,4.57,0,0,1,2.07-3.57l59.75-34.5a1.43,1.43,0,0,1,1.5-.11h0l2,1.46s-1.32.83-1.32.86l-.13,0v4.69L222.84,105.3Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,104.08v-3.32a4.57,4.57,0,0,1,2.07-3.57l59.75-34.5a1.43,1.43,0,0,1,1.5-.11h0l2,1.46s-1.32.83-1.32.86l-.13,0v4.69L222.84,105.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.84,105.3l61.91-35.75.12,42.47a4.52,4.52,0,0,1-2.05,3.57l-58.83,34,.54.67-1,1.42-2-1.46h0a1.47,1.47,0,0,1-.54-1.27l-.13-44.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.89,98.62a4.5,4.5,0,0,0-2.06,3.56v3.12l63.88-36.89V65.3c0-1.31-.93-1.84-2.07-1.18Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.89,98.62a4.5,4.5,0,0,0-2.06,3.56v3.12l63.88-36.89V65.3c0-1.31-.93-1.84-2.07-1.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.84,105.3l.12,45c0,1.31.94,1.84,2.08,1.18L284.79,117a4.54,4.54,0,0,0,2.06-3.56l-.13-45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.74 117.78 265.75 119.66 283.48 109.42 283.48 107.54 265.74 117.78",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.06 112.75 226.07 114.63 271.7 88.28 271.7 86.4 226.06 112.75",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.65 85.83 265.66 87.71 283.39 77.47 283.39 75.59 265.65 85.83",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "265.74 117.78 265.75 119.66 283.48 109.42 283.48 107.54 265.74 117.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.06 112.75 226.07 114.63 271.7 88.28 271.7 86.4 226.06 112.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.65 85.83 265.66 87.71 283.39 77.47 283.39 75.59 265.65 85.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.71 106.14 265.72 108.02 283.45 97.78 283.44 95.9 265.71 106.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.02 94.95 271.03 96.83 283.43 89.67 283.42 87.79 271.02 94.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.97 131.53 248.97 133.41 271.79 120.23 271.79 118.36 248.97 131.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.26 126.68 243.27 128.56 271.77 112.11 271.76 110.22 243.26 126.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.59 98.07 257.59 99.95 271.71 91.8 271.71 89.92 257.59 98.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.94 118.69 236.95 120.57 271.74 100.48 271.73 98.6 236.94 118.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.12 133.06 226.13 134.94 271.76 108.59 271.75 106.71 226.12 133.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.85,290.64v-3.81a5.21,5.21,0,0,1,2.37-4.1l68.58-39.59a1.65,1.65,0,0,1,1.73-.14h0l2.32,1.67s-1.51,1-1.51,1l-.16,0V251L70.11,292Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.85,290.64v-3.81a5.21,5.21,0,0,1,2.37-4.1l68.58-39.59a1.65,1.65,0,0,1,1.73-.14h0l2.32,1.67s-1.51,1-1.51,1l-.16,0V251L70.11,292Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.11,292l71.08-41,.14,48.76a5.22,5.22,0,0,1-2.37,4.09l-67.53,39,.62.77-1.13,1.62-2.31-1.67h0A1.7,1.7,0,0,1,68,342.1l-.15-51.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.47,284.37a5.23,5.23,0,0,0-2.37,4.09V292l73.33-42.34v-3.57c0-1.51-1.07-2.11-2.37-1.36Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.47,284.37a5.23,5.23,0,0,0-2.37,4.09V292l73.33-42.34v-3.57c0-1.51-1.07-2.11-2.37-1.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.11,292l.15,51.69c0,1.51,1.07,2.11,2.38,1.36l68.59-39.6a5.22,5.22,0,0,0,2.36-4.09l-.15-51.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.92 333 73.93 335.16 94.28 323.41 94.28 321.25 73.92 333",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.88 319.64 73.89 321.8 94.25 310.05 94.24 307.89 73.88 319.64",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.88 310.46 73.89 312.62 88.12 304.4 88.11 302.24 73.88 310.46",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.16 329.04 88.17 331.19 114.36 316.07 114.35 313.92 88.16 329.04",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 319.79 88.23 321.94 120.95 303.06 120.94 300.9 88.23 319.79",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.03 297.13 87.04 299.29 103.25 289.93 103.24 287.77 87.03 297.13",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.25 305.87 88.26 308.03 128.19 284.98 128.18 282.82 88.25 305.87",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 315.91 88.23 318.07 140.62 287.82 140.61 285.67 88.23 315.91",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.96 293.27 86.97 295.43 139.35 265.18 139.35 263.02 86.96 293.27",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.82 296.32 73.82 298.48 94.18 286.73 94.17 284.57 73.82 296.32",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "73.92 333 73.93 335.16 94.28 323.41 94.28 321.25 73.92 333",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.88 319.64 73.89 321.8 94.25 310.05 94.24 307.89 73.88 319.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.88 310.46 73.89 312.62 88.12 304.4 88.11 302.24 73.88 310.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.16 329.04 88.17 331.19 114.36 316.07 114.35 313.92 88.16 329.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 319.79 88.23 321.94 120.95 303.06 120.94 300.9 88.23 319.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.03 297.13 87.04 299.29 103.25 289.93 103.24 287.77 87.03 297.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.25 305.87 88.26 308.03 128.19 284.98 128.18 282.82 88.25 305.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.23 315.91 88.23 318.07 140.62 287.82 140.61 285.67 88.23 315.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.96 293.27 86.97 295.43 139.35 265.18 139.35 263.02 86.96 293.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.82 296.32 73.82 298.48 94.18 286.73 94.17 284.57 73.82 296.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.71 106.14 265.72 108.02 283.45 97.78 283.44 95.9 265.71 106.14",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.02 94.95 271.03 96.83 283.43 89.67 283.42 87.79 271.02 94.95",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.97 131.53 248.97 133.41 271.79 120.23 271.79 118.36 248.97 131.53",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.26 126.68 243.27 128.56 271.77 112.11 271.76 110.22 243.26 126.68",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.59 98.07 257.59 99.95 271.71 91.8 271.71 89.92 257.59 98.07",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.94 118.69 236.95 120.57 271.74 100.48 271.73 98.6 236.94 118.69",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.12 133.06 226.13 134.94 271.76 108.59 271.75 106.71 226.12 133.06",
    style: {
      fill: "#8A42F5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 257.14 401.51 244.64 345.75 224.94 289.98 244.64 289.98 257.35 346.11 289.76 401.88 257.35 401.51 257.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 257.14 401.51 244.64 345.75 224.94 289.98 244.64 289.98 257.35 346.11 289.76 401.88 257.35 401.51 257.14",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.43 227.69 345.73 191.49 283.43 227.69 346.13 263.9 408.43 227.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.43 227.69 345.73 191.49 283.43 227.69 346.13 263.9 408.43 227.69",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 263.9 346.07 285.73 408.37 249.53 408.43 227.69 346.13 263.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 263.9 346.07 285.73 408.37 249.53 408.43 227.69 346.13 263.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.43 227.69 283.36 249.53 346.07 285.73 346.13 263.9 283.43 227.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.69 236.09 287.67 246.31 317.02 263.26 317.05 253.03 287.69 236.09",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.82,241.41l-.86-.5c-.42-.24-.76,0-.76.44v2.24a1.69,1.69,0,0,0,.75,1.32l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,290.82,241.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,243.38l-.85-.49c-.43-.25-.77,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,294.24,243.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,245.36l-.85-.5c-.43-.24-.77,0-.77.44v2.24a1.69,1.69,0,0,0,.75,1.32l.86.49c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,297.66,245.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,247.33l-.85-.49c-.43-.25-.76-.05-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,301.08,247.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,249.31l-.85-.5c-.43-.24-.76,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,304.5,249.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.92,251.28l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,307.92,251.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,253.25l-.85-.49c-.43-.24-.76,0-.76.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,311.34,253.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,243.38l-.85-.49c-.43-.25-.77,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,294.24,243.38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,247.33l-.85-.49c-.43-.25-.76-.05-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,301.08,247.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,249.31l-.85-.5c-.43-.24-.76,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,304.5,249.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,253.25l-.85-.49c-.43-.24-.76,0-.76.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,311.34,253.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,255.23l-.85-.49c-.43-.25-.76-.05-.76.43v2.25a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,314.76,255.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,271.49a5.31,5.31,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.1h0a1.76,1.76,0,0,1,1.7.19,5.3,5.3,0,0,1,2.41,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.07L339,273h0A1.76,1.76,0,0,0,339.6,271.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,271.49a5.31,5.31,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.1h0a1.76,1.76,0,0,1,1.7.19,5.3,5.3,0,0,1,2.41,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.07L339,273h0A1.76,1.76,0,0,0,339.6,271.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,274.2h0Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,272.61a5.3,5.3,0,0,0-2.41-4.19,1.76,1.76,0,0,0-1.7-.19,1.67,1.67,0,0,0-.74,1.58,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,337.61,272.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,272.61a5.3,5.3,0,0,0-2.41-4.19,1.76,1.76,0,0,0-1.7-.19,1.67,1.67,0,0,0-.74,1.58,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,337.61,272.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,265.74a5.34,5.34,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-2,1.1h0a1.71,1.71,0,0,1,1.69.18,5.32,5.32,0,0,1,2.42,4.2,1.71,1.71,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.75,1.75,0,0,0,330.05,265.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,265.74a5.34,5.34,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-2,1.1h0a1.71,1.71,0,0,1,1.69.18,5.32,5.32,0,0,1,2.42,4.2,1.71,1.71,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.75,1.75,0,0,0,330.05,265.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,268.45h0Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,266.87a5.32,5.32,0,0,0-2.42-4.2,1.71,1.71,0,0,0-1.69-.18,1.68,1.68,0,0,0-.75,1.57,5.32,5.32,0,0,0,2.43,4.19,1.73,1.73,0,0,0,1.67.2h0l.06,0A1.71,1.71,0,0,0,328.06,266.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,266.87a5.32,5.32,0,0,0-2.42-4.2,1.71,1.71,0,0,0-1.69-.18,1.68,1.68,0,0,0-.75,1.57,5.32,5.32,0,0,0,2.43,4.19,1.73,1.73,0,0,0,1.67.2h0l.06,0A1.71,1.71,0,0,0,328.06,266.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 226.66 401.51 214.16 345.75 194.47 289.98 214.16 289.98 226.87 346.11 259.28 401.88 226.87 401.51 226.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 226.66 401.51 214.16 345.75 194.47 289.98 214.16 289.98 226.87 346.11 259.28 401.88 226.87 401.51 226.66",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.43 197.21 345.73 161.01 283.43 197.21 346.13 233.42 408.43 197.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.43 197.21 345.73 161.01 283.43 197.21 346.13 233.42 408.43 197.21",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 233.42 346.07 255.25 408.37 219.05 408.43 197.21 346.13 233.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 233.42 346.07 255.25 408.37 219.05 408.43 197.21 346.13 233.42",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.43 197.21 283.36 219.05 346.07 255.25 346.13 233.42 283.43 197.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.69 205.61 287.67 215.83 317.02 232.78 317.05 222.56 287.69 205.61",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.82,210.93l-.86-.5c-.42-.24-.76,0-.76.44v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,290.82,210.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,212.9l-.85-.49c-.43-.25-.77,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,294.24,212.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,214.88l-.85-.5c-.43-.24-.77,0-.77.44v2.25a1.69,1.69,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,297.66,214.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,216.85l-.85-.49c-.43-.25-.76-.05-.77.43V219a1.66,1.66,0,0,0,.75,1.31l.86.49c.42.25.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,301.08,216.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,218.83l-.85-.5c-.43-.24-.76,0-.77.44V221a1.69,1.69,0,0,0,.75,1.32l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,218.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.92,220.8l-.85-.49c-.43-.25-.76-.05-.77.43V223a1.65,1.65,0,0,0,.76,1.31l.85.49c.42.25.76.05.76-.43v-2.25A1.67,1.67,0,0,0,307.92,220.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,222.78l-.85-.5c-.43-.24-.76,0-.76.44V225a1.68,1.68,0,0,0,.76,1.32l.85.49c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,311.34,222.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,212.9l-.85-.49c-.43-.25-.77,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,294.24,212.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,216.85l-.85-.49c-.43-.25-.76-.05-.77.43V219a1.66,1.66,0,0,0,.75,1.31l.86.49c.42.25.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,301.08,216.85Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,218.83l-.85-.5c-.43-.24-.76,0-.77.44V221a1.69,1.69,0,0,0,.75,1.32l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,218.83Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,222.78l-.85-.5c-.43-.24-.76,0-.76.44V225a1.68,1.68,0,0,0,.76,1.32l.85.49c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,311.34,222.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,224.75l-.85-.49c-.43-.25-.76,0-.76.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,314.76,224.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,241a5.31,5.31,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.1h0a1.76,1.76,0,0,1,1.7.19,5.3,5.3,0,0,1,2.41,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.07.16-.08h0A1.75,1.75,0,0,0,339.6,241Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,241a5.31,5.31,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.1h0a1.76,1.76,0,0,1,1.7.19,5.3,5.3,0,0,1,2.41,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.07.16-.08h0A1.75,1.75,0,0,0,339.6,241Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,243.72h0Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,242.13a5.3,5.3,0,0,0-2.41-4.19,1.76,1.76,0,0,0-1.7-.19,1.68,1.68,0,0,0-.74,1.58,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,337.61,242.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,242.13a5.3,5.3,0,0,0-2.41-4.19,1.76,1.76,0,0,0-1.7-.19,1.68,1.68,0,0,0-.74,1.58,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,337.61,242.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,235.27a5.36,5.36,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l-2,1.11h0a1.71,1.71,0,0,1,1.69.18,5.33,5.33,0,0,1,2.42,4.2,1.71,1.71,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.74,1.74,0,0,0,330.05,235.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,235.27a5.36,5.36,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l-2,1.11h0a1.71,1.71,0,0,1,1.69.18,5.33,5.33,0,0,1,2.42,4.2,1.71,1.71,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.74,1.74,0,0,0,330.05,235.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,238h0Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,236.39a5.33,5.33,0,0,0-2.42-4.2A1.71,1.71,0,0,0,324,232a1.68,1.68,0,0,0-.75,1.57,5.32,5.32,0,0,0,2.43,4.19,1.73,1.73,0,0,0,1.67.2h0l.06,0A1.71,1.71,0,0,0,328.06,236.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,236.39a5.33,5.33,0,0,0-2.42-4.2A1.71,1.71,0,0,0,324,232a1.68,1.68,0,0,0-.75,1.57,5.32,5.32,0,0,0,2.43,4.19,1.73,1.73,0,0,0,1.67.2h0l.06,0A1.71,1.71,0,0,0,328.06,236.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 196.18 401.51 183.69 345.75 163.99 289.98 183.69 289.98 196.39 346.11 228.8 401.88 196.39 401.51 196.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 196.18 401.51 183.69 345.75 163.99 289.98 183.69 289.98 196.39 346.11 228.8 401.88 196.39 401.51 196.18",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.43 166.73 345.73 130.53 283.43 166.73 346.13 202.94 408.43 166.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.43 166.73 345.73 130.53 283.43 166.73 346.13 202.94 408.43 166.73",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 202.94 346.07 224.77 408.37 188.57 408.43 166.73 346.13 202.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 202.94 346.07 224.77 408.37 188.57 408.43 166.73 346.13 202.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.43 166.73 283.36 188.57 346.07 224.77 346.13 202.94 283.43 166.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.69 175.13 287.67 185.35 317.02 202.3 317.05 192.08 287.69 175.13",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.82,180.45,290,180c-.42-.25-.76-.05-.76.43v2.25A1.68,1.68,0,0,0,290,184l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,290.82,180.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,182.42l-.85-.49c-.43-.25-.77-.05-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,294.24,182.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,184.4l-.85-.5c-.43-.24-.77,0-.77.44v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,297.66,184.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,186.37l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,301.08,186.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,188.35l-.85-.5c-.43-.24-.76,0-.77.44v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,188.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.92,190.32l-.85-.49c-.43-.25-.76-.05-.77.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,307.92,190.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,192.3l-.85-.5c-.43-.24-.76,0-.76.44v2.25a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,311.34,192.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,182.42l-.85-.49c-.43-.25-.77-.05-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,294.24,182.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,186.37l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,301.08,186.37Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,188.35l-.85-.5c-.43-.24-.76,0-.77.44v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,188.35Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,192.3l-.85-.5c-.43-.24-.76,0-.76.44v2.25a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,311.34,192.3Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,194.27l-.85-.49c-.43-.25-.76-.05-.76.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.49c.42.25.76.05.76-.43v-2.25A1.67,1.67,0,0,0,314.76,194.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,210.54a5.33,5.33,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.11h0a1.73,1.73,0,0,1,1.7.18,5.32,5.32,0,0,1,2.41,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.16-.09h0A1.74,1.74,0,0,0,339.6,210.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,210.54a5.33,5.33,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.11h0a1.73,1.73,0,0,1,1.7.18,5.32,5.32,0,0,1,2.41,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.16-.09h0A1.74,1.74,0,0,0,339.6,210.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,213.24h0Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,211.66a5.32,5.32,0,0,0-2.41-4.2,1.73,1.73,0,0,0-1.7-.18,1.65,1.65,0,0,0-.74,1.57,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.69,1.69,0,0,0,337.61,211.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,211.66a5.32,5.32,0,0,0-2.41-4.2,1.73,1.73,0,0,0-1.7-.18,1.65,1.65,0,0,0-.74,1.57,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.69,1.69,0,0,0,337.61,211.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,204.79a5.36,5.36,0,0,0-2.42-4.2,1.71,1.71,0,0,0-1.69-.18h0l0,0-2,1.1h0a1.71,1.71,0,0,1,1.69.18,5.33,5.33,0,0,1,2.42,4.2,1.71,1.71,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.74,1.74,0,0,0,330.05,204.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,204.79a5.36,5.36,0,0,0-2.42-4.2,1.71,1.71,0,0,0-1.69-.18h0l0,0-2,1.1h0a1.71,1.71,0,0,1,1.69.18,5.33,5.33,0,0,1,2.42,4.2,1.71,1.71,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.74,1.74,0,0,0,330.05,204.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,207.49h0Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,205.91a5.33,5.33,0,0,0-2.42-4.2,1.71,1.71,0,0,0-1.69-.18,1.68,1.68,0,0,0-.75,1.57,5.36,5.36,0,0,0,2.43,4.2,1.76,1.76,0,0,0,1.67.19h0l.06,0A1.71,1.71,0,0,0,328.06,205.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,205.91a5.33,5.33,0,0,0-2.42-4.2,1.71,1.71,0,0,0-1.69-.18,1.68,1.68,0,0,0-.75,1.57,5.36,5.36,0,0,0,2.43,4.2,1.76,1.76,0,0,0,1.67.19h0l.06,0A1.71,1.71,0,0,0,328.06,205.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 165.7 401.51 153.21 345.75 133.51 289.98 153.21 289.98 165.91 346.11 198.32 401.88 165.91 401.51 165.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 165.7 401.51 153.21 345.75 133.51 289.98 153.21 289.98 165.91 346.11 198.32 401.88 165.91 401.51 165.7",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.43 136.25 345.73 100.05 283.43 136.25 346.13 172.46 408.43 136.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.43 136.25 345.73 100.05 283.43 136.25 346.13 172.46 408.43 136.25",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 172.46 346.07 194.29 408.37 158.09 408.43 136.25 346.13 172.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.13 172.46 346.07 194.29 408.37 158.09 408.43 136.25 346.13 172.46",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.43 136.25 283.36 158.09 346.07 194.29 346.13 172.46 283.43 136.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.69 144.65 287.67 154.87 317.02 171.82 317.05 161.6 287.69 144.65",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.82,150l-.86-.49c-.42-.25-.76,0-.76.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,290.82,150Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,151.94l-.85-.49c-.43-.24-.77,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,294.24,151.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,153.92l-.85-.49c-.43-.25-.77-.05-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,297.66,153.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,155.89l-.85-.49c-.43-.24-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,301.08,155.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,157.87l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,157.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.92,159.84l-.85-.49c-.43-.24-.76,0-.77.43V162a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.25A1.69,1.69,0,0,0,307.92,159.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,161.82l-.85-.5c-.43-.24-.76,0-.76.44V164a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,311.34,161.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,151.94l-.85-.49c-.43-.24-.77,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,294.24,151.94Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,155.89l-.85-.49c-.43-.24-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,301.08,155.89Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,157.87l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,157.87Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.34,161.82l-.85-.5c-.43-.24-.76,0-.76.44V164a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,311.34,161.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,163.79l-.85-.49c-.43-.25-.76-.05-.76.43V166a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44V165.1A1.67,1.67,0,0,0,314.76,163.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,180.06a5.33,5.33,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l0,0-1.95,1.1h0a1.73,1.73,0,0,1,1.7.18,5.32,5.32,0,0,1,2.41,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.16-.09h0A1.74,1.74,0,0,0,339.6,180.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,180.06a5.33,5.33,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l0,0-1.95,1.1h0a1.73,1.73,0,0,1,1.7.18,5.32,5.32,0,0,1,2.41,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.16-.09h0A1.74,1.74,0,0,0,339.6,180.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,182.76h0Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,181.18a5.32,5.32,0,0,0-2.41-4.2,1.73,1.73,0,0,0-1.7-.18,1.65,1.65,0,0,0-.74,1.57,5.35,5.35,0,0,0,2.42,4.2,1.76,1.76,0,0,0,1.67.19h0l.05,0A1.69,1.69,0,0,0,337.61,181.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.61,181.18a5.32,5.32,0,0,0-2.41-4.2,1.73,1.73,0,0,0-1.7-.18,1.65,1.65,0,0,0-.74,1.57,5.35,5.35,0,0,0,2.42,4.2,1.76,1.76,0,0,0,1.67.19h0l.05,0A1.69,1.69,0,0,0,337.61,181.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,174.31a5.37,5.37,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.18h0l0,0-2,1.1h0a1.69,1.69,0,0,1,1.69.19,5.31,5.31,0,0,1,2.42,4.19,1.7,1.7,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.73,1.73,0,0,0,330.05,174.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.05,174.31a5.37,5.37,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.18h0l0,0-2,1.1h0a1.69,1.69,0,0,1,1.69.19,5.31,5.31,0,0,1,2.42,4.19,1.7,1.7,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.73,1.73,0,0,0,330.05,174.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,177h0Z",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,175.43a5.31,5.31,0,0,0-2.42-4.19,1.48,1.48,0,0,0-2.44,1.38,5.36,5.36,0,0,0,2.43,4.2,1.73,1.73,0,0,0,1.67.19h0l.06,0A1.7,1.7,0,0,0,328.06,175.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,175.43a5.31,5.31,0,0,0-2.42-4.19,1.48,1.48,0,0,0-2.44,1.38,5.36,5.36,0,0,0,2.43,4.2,1.73,1.73,0,0,0,1.67.19h0l.06,0A1.7,1.7,0,0,0,328.06,175.43Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.83,276.54H377s8.32,54.63,8.89,65.1a.92.92,0,0,1-.54.75,2.84,2.84,0,0,1-2.57,0,.9.9,0,0,1-.5-.65h0C381.24,335.49,369.83,276.54,369.83,276.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,276.54s.36,2.35.92,6.13c-1.14,2.46-3.62,5.14-5.89,5.19-.89-4.59-2.19-11.32-2.19-11.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.86,322.35H370.7s-8.32,54.63-8.9,65.11a.89.89,0,0,0,.54.74,2.8,2.8,0,0,0,2.58,0,.93.93,0,0,0,.5-.65h0C366.45,381.3,377.86,322.35,377.86,322.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.7,322.35s-.36,2.35-.93,6.14a18.89,18.89,0,0,0,6.63,1.38c.89-4.6,1.46-7.52,1.46-7.52Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,298.69h7.16s8.32,54.63,8.89,65.1a.93.93,0,0,1-.53.75,2.86,2.86,0,0,1-2.58,0,1,1,0,0,1-.5-.65h0C420.51,357.64,409.1,298.69,409.1,298.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.26,298.69s.36,2.35.93,6.13c-1.14,2.46-3.63,5.14-5.9,5.19-.89-4.59-2.19-11.32-2.19-11.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.48,297.94h-7.16S320,352.57,319.43,363a.92.92,0,0,0,.54.75,2.84,2.84,0,0,0,2.57,0,.89.89,0,0,0,.5-.66h0C324.07,356.89,335.48,297.94,335.48,297.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.32,297.94s-.36,2.35-.92,6.13c1.22,1.45,3.9,3.68,6.18,3.73.88-4.59,1.9-9.86,1.9-9.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.76 250.16 410.62 289.99 414.44 292.86 417.88 251.84 413.76 250.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.38 227.38 370.24 267.2 374.07 270.08 377.5 229.05 373.38 227.38",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.73,262s-23.93,6.74-42.37,24.47v7.26c3.4,4.08,29.29,24.25,56.5,32.62C396,318,414,304,417.13,300.12v-7.26C410.29,279.49,363.73,262,363.73,262Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.36,286.5v7.26c3.4,4.08,29.29,24.25,56.5,32.62v-7.26C350.65,310.75,324.76,290.58,321.36,286.5Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.86,319.12v7.26C396,318,414,304,417.13,300.12v-7.26C414,296.69,396,310.75,377.86,319.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.71,242a3.07,3.07,0,0,0-.47-1.62c-15.95-25-49-32.72-56.34-30.83L366.48,213v17.93c25.5,3.24,47.37,19.87,56.2,32.69l1.18-.46a4.53,4.53,0,0,0,2.86-4.2V242Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.71,242a3.17,3.17,0,0,1-2.08,3l-1.95.7v17.92l1.18-.46a4.53,4.53,0,0,0,2.86-4.2V242Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.68,245.7l1.95-.7a3.17,3.17,0,0,0,2.08-3,3.07,3.07,0,0,0-.47-1.62c-15.95-25-49-32.72-56.34-30.83L366.48,213C373.83,211.65,410.17,218.91,422.68,245.7Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.48,213v17.93c25.5,3.24,47.37,19.87,56.2,32.69V245.7C410.17,218.91,373.83,211.65,366.48,213Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.74,405.48l1,5.94c4.71-2.24,6.23-4.77,6.23-4.77.12-4.56.06-9.25,0-11.53-1.25,2.77-4,4.64-5.7,7.2A14.44,14.44,0,0,0,318.74,405.48Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,410.78l2.51.64-1-5.94C318.12,407.19,317.71,409,317.22,410.78Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.74,405.48l1,5.94c4.71-2.24,6.23-4.77,6.23-4.77.12-4.56.06-9.25,0-11.53-1.25,2.77-4,4.64-5.7,7.2A14.44,14.44,0,0,0,318.74,405.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,410.78l2.51.64-1-5.94C318.12,407.19,317.71,409,317.22,410.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.21,388.54a24.47,24.47,0,0,0-1.95-4.53,13,13,0,0,1-2.18,6.84c-1.7,2.73-4,5.09-5.59,7.86-2,3.38-3,7.36-5.61,10.28a12.33,12.33,0,0,1-10.27,4,5.42,5.42,0,0,1-3.76-1.69,2.94,2.94,0,0,1-.62-1.79,27.63,27.63,0,0,1-4.23,3.71c-1.72,1.19-3.77,2.45-4.05,4.52a4.43,4.43,0,0,0,2.46,4.21,11.58,11.58,0,0,0,5,1.12,31.69,31.69,0,0,0,11-.94,15.31,15.31,0,0,0,8.81-6.39,19.73,19.73,0,0,0,2-5c.49-1.78.9-3.59,1.52-5.3a14.44,14.44,0,0,1,1.54-3.16c1.71-2.56,4.45-4.43,5.7-7.2.07-.15.15-.29.21-.44A9.84,9.84,0,0,0,326.21,388.54Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.61,413a12.33,12.33,0,0,0,10.27-4c2.6-2.92,3.63-6.9,5.61-10.28,1.63-2.77,3.89-5.13,5.59-7.86a13,13,0,0,0,2.18-6.84c.46-1.77,1.36-3.87,1.16-4.25-4.88-.43-8.13-1.65-13.6-2.42a245.2,245.2,0,0,1-9.62,23.52,37.67,37.67,0,0,1-6,8.65,2.94,2.94,0,0,0,.62,1.79A5.42,5.42,0,0,0,300.61,413Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.71,352.28c-.6,9.45-3,16.29-4.86,29.18,0,0-11.31,3.37-18.36-1.55l-.29-19.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46,391.85l1,5.93c4.71-2.24,6.23-4.77,6.23-4.77.12-4.56.07-9.25,0-11.53-1.25,2.77-4,4.65-5.7,7.2A14.33,14.33,0,0,0,283.46,391.85Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,397.14l2.5.64-1-5.93C282.85,393.55,282.44,395.37,282,397.14Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.46,391.85l1,5.93c4.71-2.24,6.23-4.77,6.23-4.77.12-4.56.07-9.25,0-11.53-1.25,2.77-4,4.65-5.7,7.2A14.33,14.33,0,0,0,283.46,391.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,397.14l2.5.64-1-5.93C282.85,393.55,282.44,395.37,282,397.14Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.93,374.9a23.77,23.77,0,0,0-1.94-4.53,13,13,0,0,1-2.19,6.84c-1.69,2.74-4,5.09-5.58,7.87-2,3.37-3,7.35-5.62,10.28a12.3,12.3,0,0,1-10.26,4,5.39,5.39,0,0,1-3.76-1.69,3,3,0,0,1-.63-1.79,26.72,26.72,0,0,1-4.23,3.71c-1.71,1.2-3.77,2.46-4.05,4.53a4.45,4.45,0,0,0,2.46,4.21,11.59,11.59,0,0,0,5,1.12,32,32,0,0,0,11-.95,15.29,15.29,0,0,0,8.8-6.39,19.76,19.76,0,0,0,2-5c.49-1.77.9-3.59,1.51-5.29a14.33,14.33,0,0,1,1.55-3.17c1.7-2.55,4.45-4.43,5.7-7.2a4.28,4.28,0,0,0,.2-.44A9.77,9.77,0,0,0,290.93,374.9Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34,399.35a12.3,12.3,0,0,0,10.26-4c2.61-2.93,3.63-6.91,5.62-10.28,1.62-2.78,3.89-5.13,5.58-7.87a13,13,0,0,0,2.19-6.84c.45-1.77,1.36-3.87,1.15-4.25-4.88-.43-8.13-1.65-13.59-2.42a245.27,245.27,0,0,1-9.63,23.52,37.46,37.46,0,0,1-6,8.65,3,3,0,0,0,.63,1.79A5.39,5.39,0,0,0,265.34,399.35Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,341.21c-2.18,9.21-5.72,15.55-9.72,27.94,0,0-11.73,1.41-17.84-4.64l5.26-32.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.79,315.67c6.76-2.91,37.39-18.16,17.12-47.76l-50.25-7.21c-1.65,15.77-16.14,26.1-16.14,26.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.72,277.07a54.59,54.59,0,0,0,27.19-9.16,70.8,70.8,0,0,0-7.77-11.15l-44.86,4q-.66,5.58-1,11A54.6,54.6,0,0,0,362.72,277.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.59,198.39a9.22,9.22,0,0,1,.09-3.55c.23-1,3.07-7,2.69-7.38a14.92,14.92,0,0,1-1.8-18.74,5,5,0,0,1,.91-9.65c1.81-.31,3.62.38,5.43.77a26.17,26.17,0,0,0,9.34,0c3.09-.45,6.17-1.12,9.29-1.35a18.83,18.83,0,0,1,9.2,1.31,10.27,10.27,0,0,1,5.95,6.83c4.63-.91,10,2.87,10.86,7.51s-1.82,9-1.41,13.57a15.12,15.12,0,0,0,4,8.24c2,2.35,4.41,4.35,6.51,6.62a37.27,37.27,0,0,1,9.79,22.9c.28,4.76-.44,9.75-3.1,13.71-5.22,7.78-19.23,9.73-27.84,9.4a45.88,45.88,0,0,1-24.6-8.33c-5-3.5-9.51-8.71-9.33-14.78.08-2.86,1.2-5.56,2-8.32s1.13-5.83-.2-8.36-4.3-4.1-6.08-6.49A8.86,8.86,0,0,1,334.59,198.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.86,221.42a7.42,7.42,0,0,0,4.8,1.28,26.86,26.86,0,0,0,21.41-10.62l-4.76-.42v-15.3l-16.53,6.38v8.84h-4.24a12.4,12.4,0,0,0-2,3.59C344.8,217.32,345.12,220,346.86,221.42Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.15,196.8c-2.68,6.06-8,11.26-15.37,12.12v-6.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.37,184.58a15.22,15.22,0,0,0-.18,3.87,4.56,4.56,0,0,0,1.28,2.59,2.87,2.87,0,0,0,2.61.77,5.05,5.05,0,0,1,9.81-2.4,6.33,6.33,0,0,1-1.06,5.26,11.83,11.83,0,0,1-4.22,3.52,4.29,4.29,0,0,1-5.1-2c-4.91,6.23-13.48,10.9-21.51,10.23a11.48,11.48,0,0,1-6.11-2.15c-3-2.35-3.26-5.9-3.64-9.4a49.73,49.73,0,0,1,.1-13.35c1-6.1,3.7-12.1,8.44-16.07C348.54,178.72,360.71,183.6,365.37,184.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.65 183.07 343.15 189.84 348.26 191.6 348.65 183.07",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,194.9l-4.28,1.36a2.65,2.65,0,0,0,2.9,1.31A2.39,2.39,0,0,0,353,194.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,194.9l-4.28,1.36a2.65,2.65,0,0,0,2.9,1.31A2.39,2.39,0,0,0,353,194.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.17,197.49a2.44,2.44,0,0,0,1.41.08,2.18,2.18,0,0,0,1.38-1.95,2.58,2.58,0,0,0-1.66.31A2.53,2.53,0,0,0,350.17,197.49Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.22,184.48a1.53,1.53,0,1,1-1.46-1.6A1.52,1.52,0,0,1,356.22,184.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.44,183.41a1.53,1.53,0,1,1-1.46-1.6A1.52,1.52,0,0,1,343.44,183.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.23,177.27l-3.49,2.19a2.2,2.2,0,0,1,.77-2.37A2.58,2.58,0,0,1,342.23,177.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.29,177.68l3.28,2.49a2.2,2.2,0,0,0-.55-2.43A2.58,2.58,0,0,0,355.29,177.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.79,268.62c-8.54-12.84-9.05-21.83-4.79-29.41,1.3-2.3,1.08-11.58.71-18.37a8.66,8.66,0,0,0-7.91-8.18l-6.73-.58a26.86,26.86,0,0,1-21.41,10.62c-2.5,0-5.26-.45-6.26-3.51a5.73,5.73,0,0,1-.21-2.63,10.6,10.6,0,0,1,2.35-5h-4.11c-4.94,4.39-14.28,22.16-14.86,31.72-.29,4.8,3.41,7.16,6,8.65,0,0,1.74,7.08-.85,20.22C346.3,281.07,375.67,282,391.79,268.62Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.86,243.22a17.78,17.78,0,0,1-21.37,6.28,13.21,13.21,0,0,0,12.2,3.4C366,251.81,369.59,247.43,370.86,243.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,210.19v1.47l-8.13,34S361,263.64,371.87,284c12.32,2.32,22.26-4.42,24.87-7.77-7.46-10.16-12.4-30-12.4-30l-1.27-33.43-13.77-.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,211.66v-1.47l3.89,6.94a2.16,2.16,0,0,1-.28,2.5l-4.38,4.9,2.25,2.14a2.17,2.17,0,0,1,.36,2.7l-10,16.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,211.66v-1.47l3.89,6.94a2.16,2.16,0,0,1-.28,2.5l-4.38,4.9,2.25,2.14a2.17,2.17,0,0,1,.36,2.7l-10,16.32Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,219.31l-9.38,40.86-1.95.7.85-5.53a143.63,143.63,0,0,1,10.48-36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.39,266.8l1.88-13.89c-1.25-4-1.93-6.75-1.93-6.75l-.3-7.72-16.93,35.29c.62,1.54,1.29,3.11,2,4.72L375,277.1A12.27,12.27,0,0,0,384.39,266.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,274.24c-.06-11.46,0-24.76,1.13-32.14,3.69-16.63,8.51-22.85,12.61-30.52h2.32v-2.66l-3.68,2.66h-4.67c-16.94,19.95-16.86,30.93-17,34.11s.51,23.49.51,23.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,216a2.18,2.18,0,0,0-.89,1.93l.31,4-3.85,1.5a2.18,2.18,0,0,0-1.38,2.16l1,15.12c3.64-15.56,8.3-21.66,12.28-29.11h2.32v-2.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342,216a2.18,2.18,0,0,0-.89,1.93l.31,4-3.85,1.5a2.18,2.18,0,0,0-1.38,2.16l1,15.12c3.64-15.56,8.3-21.66,12.28-29.11h2.32v-2.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "177.33 285.38 177.33 382.99 180.78 381 180.78 283.38 177.33 285.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.33 285.38 177.33 382.99 173.88 381 173.88 283.38 177.33 285.38",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.78 311.41 261.57 264.77 261.57 261.06 180.78 307.7 180.78 311.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.78 303.78 258.12 259.07 261.57 261.06 180.78 307.7 180.78 303.78",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.65 318.26 402.65 415.87 406.1 413.88 406.1 316.26 402.65 318.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.65 318.26 402.65 415.87 399.2 413.88 399.2 316.26 402.65 318.26",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 366.91 318.41 464.52 321.86 462.53 321.86 364.91 318.41 366.91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 366.91 318.41 464.52 314.96 462.53 314.96 364.91 318.41 366.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.86 392.94 402.65 346.3 402.65 342.59 321.86 389.23 321.86 392.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.86 385.31 399.2 340.6 402.65 342.59 321.86 389.23 321.86 385.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "402.65 318.26 402.65 415.87 406.1 413.88 406.1 316.26 402.65 318.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.65 318.26 402.65 415.87 399.2 413.88 399.2 316.26 402.65 318.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 366.91 318.41 464.52 321.86 462.53 321.86 364.91 318.41 366.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 366.91 318.41 464.52 314.96 462.53 314.96 364.91 318.41 366.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.86 392.94 402.65 346.3 402.65 342.59 321.86 389.23 321.86 392.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.86 385.31 399.2 340.6 402.65 342.59 321.86 389.23 321.86 385.31",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "177.33 285.38 177.33 382.99 180.78 381 180.78 283.38 177.33 285.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.33 285.38 177.33 382.99 173.88 381 173.88 283.38 177.33 285.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.78 311.41 261.57 264.77 261.57 261.06 180.78 307.7 180.78 311.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.78 303.78 258.12 259.07 261.57 261.06 180.78 307.7 180.78 303.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 357.49 173.87 274.24 261.56 223.59 406.1 306.84 318.41 357.49",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 366.91 173.87 283.38 173.87 274.24 318.41 357.49 318.41 366.91",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 357.48 406.1 306.83 406.1 316.26 318.41 366.91 318.41 357.48",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 357.49 173.87 274.24 261.56 223.59 406.1 306.84 318.41 357.49",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 357.48 406.1 306.83 406.1 316.26 318.41 366.91 318.41 357.48",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.41 366.91 173.87 283.38 173.87 274.24 318.41 357.49 318.41 366.91",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.7,332a16.65,16.65,0,0,0-15.09,0c-4.15,2.42-4.13,6.33.05,8.74a16.59,16.59,0,0,0,15.09,0C329.9,338.33,329.88,334.42,325.7,332Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.32,316.82l-11.46.33-11.47-.33c-.49,7.74,1,15.63,3.1,19.49h0a5.21,5.21,0,0,0,2.27,2.31,13.47,13.47,0,0,0,12.21,0,5.05,5.05,0,0,0,2.27-2.37C328.32,332.37,329.82,324.52,329.32,316.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.94,312.12c4.49,2.6,4.52,6.8.05,9.4s-11.72,2.59-16.22,0-4.51-6.8,0-9.4S321.45,309.53,325.94,312.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.16,313.15c3.51,2,3.53,5.31,0,7.33a13.9,13.9,0,0,1-12.65,0c-3.5-2-3.52-5.3,0-7.33A14,14,0,0,1,324.16,313.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.16,313.15c3.51,2,3.53,5.31,0,7.33a13.9,13.9,0,0,1-12.65,0c-3.5-2-3.52-5.3,0-7.33A14,14,0,0,1,324.16,313.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,317.14a7.53,7.53,0,0,0,6.73,1.53,7.05,7.05,0,0,0,4.71-4.76,13.69,13.69,0,0,1-3.68-2.56,9.44,9.44,0,0,1,5.21.19,5.29,5.29,0,0,0,.39-5,9.08,9.08,0,0,0-6.21-.43,8.26,8.26,0,0,1,6.28-2,24.05,24.05,0,0,0-1.51-9.65c-4.27.22-8.42,2.06-9.81,3.39a15.56,15.56,0,0,0,.47,4.54,3.69,3.69,0,0,1-2-2.94c-2.67.67-3.82,2-4.24,3a11.29,11.29,0,0,0,2.54,5.13,6.18,6.18,0,0,1-3.53-3.56C309.79,309.94,310.26,316.57,316.9,317.14Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,317.14a7.53,7.53,0,0,0,6.73,1.53,7.05,7.05,0,0,0,4.71-4.76,13.69,13.69,0,0,1-3.68-2.56,9.44,9.44,0,0,1,5.21.19,5.29,5.29,0,0,0,.39-5,9.08,9.08,0,0,0-6.21-.43,8.26,8.26,0,0,1,6.28-2,24.05,24.05,0,0,0-1.51-9.65c-4.27.22-8.42,2.06-9.81,3.39a15.56,15.56,0,0,0,.47,4.54,3.69,3.69,0,0,1-2-2.94c-2.67.67-3.82,2-4.24,3a11.29,11.29,0,0,0,2.54,5.13,6.18,6.18,0,0,1-3.53-3.56C309.79,309.94,310.26,316.57,316.9,317.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,317.14a7.53,7.53,0,0,0,6.73,1.53,7.05,7.05,0,0,0,4.71-4.76,13.69,13.69,0,0,1-3.68-2.56,9.44,9.44,0,0,1,5.21.19,5.29,5.29,0,0,0,.39-5,9.08,9.08,0,0,0-6.21-.43,8.26,8.26,0,0,1,6.28-2,24.05,24.05,0,0,0-1.51-9.65c-4.27.22-8.42,2.06-9.81,3.39a15.56,15.56,0,0,0,.47,4.54,3.69,3.69,0,0,1-2-2.94c-2.67.67-3.82,2-4.24,3a11.29,11.29,0,0,0,2.54,5.13,6.18,6.18,0,0,1-3.53-3.56C309.79,309.94,310.26,316.57,316.9,317.14Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.75,317.78h0a.26.26,0,0,1-.23-.27c.41-5.4,3.5-14.31,10.87-21.66a.23.23,0,0,1,.34,0,.24.24,0,0,1,0,.35c-7.26,7.25-10.31,16-10.71,21.35A.25.25,0,0,1,316.75,317.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.77,320a7,7,0,0,1-11-2.88,11.92,11.92,0,0,0,3.33-2.27,9.48,9.48,0,0,0-4.93.15,4.58,4.58,0,0,1-.69-4.43,9,9,0,0,1,5.87-.35,8.74,8.74,0,0,0-6.09-1.81,19.6,19.6,0,0,1,.82-8.62c4.08.25,8.11,1.94,9.51,3.13a12.9,12.9,0,0,1-.16,4,2.93,2.93,0,0,0,1.68-2.59c2.56.62,3.71,1.81,4.16,2.72a8.93,8.93,0,0,1-2.06,4.53,5.05,5.05,0,0,0,3.09-3.13C325,313.69,324.94,319.54,318.77,320Z",
    style: {
      fill: "#8A42F5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.77,320a7,7,0,0,1-11-2.88,11.92,11.92,0,0,0,3.33-2.27,9.48,9.48,0,0,0-4.93.15,4.58,4.58,0,0,1-.69-4.43,9,9,0,0,1,5.87-.35,8.74,8.74,0,0,0-6.09-1.81,19.6,19.6,0,0,1,.82-8.62c4.08.25,8.11,1.94,9.51,3.13a12.9,12.9,0,0,1-.16,4,2.93,2.93,0,0,0,1.68-2.59c2.56.62,3.71,1.81,4.16,2.72a8.93,8.93,0,0,1-2.06,4.53,5.05,5.05,0,0,0,3.09-3.13C325,313.69,324.94,319.54,318.77,320Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.93,320.62a.25.25,0,0,1-.24-.21c-.7-4.7-4.12-12.5-11.44-19a.25.25,0,0,1,0-.35.24.24,0,0,1,.35,0c7.42,6.6,10.89,14.53,11.6,19.32a.25.25,0,0,1-.21.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,270.75l34.07-19.81a7.77,7.77,0,0,1,7,0L344.5,283.4a2.53,2.53,0,0,1,1.45,1.92h0v2.16h0a1.68,1.68,0,0,1,0,.45.09.09,0,0,0,0,.05,2.15,2.15,0,0,1-.24.48l0,.05a2.58,2.58,0,0,1-.42.47l0,0a3.81,3.81,0,0,1-.62.45l-34.08,19.8a5.1,5.1,0,0,1-1,.43c-.12.05-.24.08-.37.12s-.33.09-.5.12-.4.08-.6.1l-.15,0a7.55,7.55,0,0,1-.83,0h-.13c-.28,0-.56,0-.83,0l-.12,0a7,7,0,0,1-.8-.14l-.14,0a6.75,6.75,0,0,1-.68-.21l-.13,0a4.71,4.71,0,0,1-.75-.36L247.23,276.8a4.53,4.53,0,0,1-.64-.45l-.16-.18a4.2,4.2,0,0,1-.29-.32,2.26,2.26,0,0,1-.11-.22,2,2,0,0,1-.17-.32c0-.07,0-.15,0-.23a1.64,1.64,0,0,1,0-.32v-2A2.46,2.46,0,0,1,247.22,270.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,285.32a1.84,1.84,0,0,1-.06.62.08.08,0,0,0,0,0,1.8,1.8,0,0,1-.24.48l0,.05a2.29,2.29,0,0,1-.42.47l0,0a3.81,3.81,0,0,1-.62.45l-34.08,19.8a5.81,5.81,0,0,1-1,.43l-.37.11-.5.13c-.2,0-.4.08-.6.1l-.15,0c-.27,0-.55,0-.83.05h-.13a7.55,7.55,0,0,1-.83-.05H306a7,7,0,0,1-.8-.14l-.14,0a6.75,6.75,0,0,1-.68-.21l-.13,0a5.77,5.77,0,0,1-.75-.36L247.23,274.8a4.53,4.53,0,0,1-.64-.45c-.06-.05-.1-.11-.16-.17a4.28,4.28,0,0,1-.29-.33,2.12,2.12,0,0,1-.11-.21,2.48,2.48,0,0,1-.17-.32c0-.08,0-.16,0-.23a1.77,1.77,0,0,1,0-.32v2a1.64,1.64,0,0,0,0,.32c0,.08,0,.16,0,.23a2,2,0,0,0,.17.32,2.26,2.26,0,0,0,.11.22,4.2,4.2,0,0,0,.29.32l.16.18a4.53,4.53,0,0,0,.64.45l56.22,32.45a4.71,4.71,0,0,0,.75.36l.13,0a6.75,6.75,0,0,0,.68.21l.14,0a7,7,0,0,0,.8.14l.12,0c.27,0,.55,0,.83,0H307a7.55,7.55,0,0,0,.83,0l.15,0c.2,0,.4-.06.6-.1s.34-.08.5-.12.25-.07.37-.12a5.1,5.1,0,0,0,1-.43l34.08-19.8a3.81,3.81,0,0,0,.62-.45l0,0a2.58,2.58,0,0,0,.42-.47l0-.05a2.15,2.15,0,0,0,.24-.48.09.09,0,0,1,0-.05,1.68,1.68,0,0,0,0-.45h0v-2.16Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,272.77l54.61,31.53.22.11.11,0c.11,0,.21.07.43.12a2.73,2.73,0,0,0,.3.06l.21,0a3.7,3.7,0,0,0,.53,0H307a4,4,0,0,0,.56,0l.35-.06.45-.12a1.51,1.51,0,0,0,.37-.15l17.57-10.22L269.9,261.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,304.68h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,264.1l-10.27,6a1,1,0,0,0,0,1.8l15.36,8.87a1.73,1.73,0,0,0,1.72,0l10.27-6a1,1,0,0,0,0-1.8l-15.37-8.87A1.71,1.71,0,0,0,302.5,264.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,272.77l54.61,31.53.22.11.11,0c.11,0,.21.07.43.12a2.73,2.73,0,0,0,.3.06l.21,0a3.7,3.7,0,0,0,.53,0H307a4,4,0,0,0,.56,0l.35-.06.45-.12a1.51,1.51,0,0,0,.37-.15l17.57-10.22L269.9,261.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,264.1l-10.27,6a1,1,0,0,0,0,1.8l15.36,8.87a1.73,1.73,0,0,0,1.72,0l10.27-6a1,1,0,0,0,0-1.8l-15.37-8.87A1.71,1.71,0,0,0,302.5,264.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.85,272.94c-3.12,4.21-.55,10.84,3.47,11.6C338.1,280.71,333.26,273.57,327.85,272.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.45,274.57l-6.31,2.75a1.59,1.59,0,0,0-.95,1.6h0a1.59,1.59,0,0,0,1.58,1.45h6Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53,275.51l-5.62-2.61a3.74,3.74,0,0,0-4.18.7l-4,3.83a3.11,3.11,0,0,0-.94,1.95l-.4,4.09A1.48,1.48,0,0,0,308.5,285h0a1.48,1.48,0,0,0,1.83-1.28l.35-3.58,2.09-2.33-1.15,1.79a2.72,2.72,0,0,0-.44,1.59l.1,3.08a2.62,2.62,0,0,0,1.49,2.28l4.87,2.33a2.61,2.61,0,0,0,2.59-.19,21.29,21.29,0,0,0,2.12-1.63,1.33,1.33,0,0,0,.18-1.4l2.23-1.62,44.94-7.69-10.83-14.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53,285.7a5.07,5.07,0,0,1-3.09.52,9,9,0,0,0,.11-3.05,4.37,4.37,0,0,1,.9,2.31A3,3,0,0,0,322.53,285.7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.07,212.73a8.5,8.5,0,0,0-8.89,6.58l-9.38,40.86-5.93,2.15-31,10.62c5.28,4,3.47,11.6,3.47,11.6l38.38-8.15a16.32,16.32,0,0,0,13.26-13l7.85-40.57A8.5,8.5,0,0,0,383.07,212.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.8,260.17c4.14,0,7.39,4.28,7.8,5.86.81-8.35-4-8.68-7.46-7.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.16,211.53a27.09,27.09,0,0,0-18.49,6.72L299.35,238.7a21.68,21.68,0,0,0-3.91,4.53l-12.16,18.83,12.19,8.09,13-18.79L327.61,238c1.63-5.77,5.67-14.5,15.82-26.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.7,242.16l5.91-4.12c1.29-4.58,4.12-11,10.29-19.47A55.64,55.64,0,0,0,321.7,242.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,231.05h0l1.35-.67h0a1.66,1.66,0,0,1,1.51.09l56.6,32.91a6.82,6.82,0,0,1,3.32,4.85l5.82,37a1.69,1.69,0,0,1-.95,1.79h0l-1.3.64h0a1.65,1.65,0,0,1-1.46-.12l-56.6-32.91A6.82,6.82,0,0,1,243,269.8l-5.82-37A1.68,1.68,0,0,1,238,231.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.91,264.92a12.51,12.51,0,0,1,5.62,8.09c.37,2.89-1.54,4-4.28,2.38a12.56,12.56,0,0,1-5.62-8.1C264.26,264.41,266.18,263.34,268.91,264.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.48,305.81l-5.82-37a6.82,6.82,0,0,0-3.32-4.85l-56.6-32.91a1.69,1.69,0,0,0-1.7,0h0l1.35-.67h0a1.66,1.66,0,0,1,1.51.09l56.6,32.91a6.82,6.82,0,0,1,3.32,4.85l5.82,37a1.69,1.69,0,0,1-.95,1.79h0l-1.3.64h0A1.7,1.7,0,0,0,305.48,305.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.2f78329b90730194910d2a3327066d00.svg";
export { ForwardRef as ReactComponent };